import { createApp } from "vue";
import App from "./App.vue";
import store from "./store";
import router from "./router";

// Tailwind disabled
// import "/assets/tailwind.css";
import "./assets/main.css";
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/js/bootstrap.bundle.min.js";
import "@fortawesome/fontawesome-free/css/all.min.css";

import "./assets/css/style.css";
import "@/assets/main.css";

const app = createApp(App);

app.use(store);
app.use(router);

app.mount("#app");
